<style>
  table {
    border-collapse: collapse;
    width: 100%;
  }
  th, td {
    border: 1px solid white; 
    padding: 3px; 
  }
</style>

<div class="card" *appIsGranted="['PACKETS_HYUNDAI', 'PACKETS_HYUNDAI', 'READ']">
  <!-- Aba 1 -->
  <div class="card-body">
    <button 
      type="button"
      class="btn btn-primary btn-sm"
      (click)="toggleTab('tab1')" 
      style="width: 100%; background-color: #cde8f8 ;color: gray; text-align: center; border: none; padding: 25px; cursor: pointer; font-size: medium;">
      <b>Consultar Posição Hyundai</b>
    </button>
    <div style="text-align: center; color: red; font-weight: bold">
      A utilização deste recurso poderá gerar custos, caso retorne informações de localização do veículo!
    </div>
    <div *ngIf="expandedTab === 'tab1'" style="border: 1px solid #cde8f8; padding: 30px;">
      <div 
        style="display: flex">
      <input 
        id="input1"  
        placeholder="Digite o chassi"
        required 
        minlength="17" 
        maxlength="17"
        [(ngModel)]="chassiPosition">
      <button 
        (click)="getPosition()"
        type="button" class="btn btn-primary btn-sm" style="margin-right: 4px;"
        >Buscar</button>
      </div>
      <p *ngIf="messageErrorTab1" style="color: red; font-weight: bold;">{{ messageErrorTab1 }}</p>
      <div style="margin-bottom: 20px;"></div>
      <table 
      *ngIf="responsePosition" border="1" 
      style="width: 100%; text-align: center; border-collapse: collapse;">
        <tr>
          <th style="background-color: #cde8f8">Chassi</th>
          <th style="background-color: #cde8f8"> Status </th>
          <th style="background-color: #cde8f8">Mensagem</th>
          <th style="background-color: #cde8f8"> Latitude </th>
          <th style="background-color: #cde8f8"> Longitude </th>
          <th style="background-color: #cde8f8">Altitude</th>
          <th style="background-color: #cde8f8">Tipo de Localização</th>
          <th style="background-color: #cde8f8">Data da Localização</th>
        </tr>
        <tr>
          <td>{{ responsePosition.chassi }}</td>
          <td>{{ responsePosition.status }}</td>
          <td>{{ responsePosition.message }}</td>  
          <td>{{ responsePosition.latitude }}</td>   
          <td>{{ responsePosition.longitude }}</td>
          <td>{{ responsePosition.altitude }}</td>  
          <td>{{ responsePosition.typeLocation }}</td> 
          <td>{{ responsePosition.dateLocation.slice(6, 8) }}/{{ responsePosition.dateLocation.slice(4, 6) }}/{{ responsePosition.dateLocation.slice(0, 4) }}
            {{ responsePosition.dateLocation.slice(8, 10) }}:{{ responsePosition.dateLocation.slice(10, 12) }}:{{ responsePosition.dateLocation.slice(12, 14) }}
          </td> 
        </tr>
      </table>              
      <div *ngIf="responsePositionStatus" style="color: red; margin-top: 30px;">
        <p>Item adicionado ao faturamento da Hyundai!</p>
      </div>
    </div>
  </div>  
</div>

<div class="card" *appIsGranted="['PACKETS_HYUNDAI', 'PACKETS_HYUNDAI', 'READ']">
    <!-- Aba 2 -->
    <div class="card-body" style="margin-top: 10px;">
      <button 
      type="button"
      class="btn btn-primary btn-sm"
      (click)="toggleTab('tab2')" 
      style="width: 100%; background-color: #cde8f8; color: gray; text-align: center; border: none; padding: 25px; cursor: pointer; font-size: medium;">
          <b>Histórico de Consultas</b>
      </button>
      <div *ngIf="expandedTab === 'tab2'" style="border: 1px solid #cde8f8; padding: 30px;">
        <div 
        style="display: flex">
        <input 
          id="input2" 
          placeholder="Digite o chassi"
          required 
          minlength="17" 
          maxlength="17"
          [(ngModel)]="chassiHistory">
        <button 
          (click)="getHistory()"
          type="button" class="btn btn-primary btn-sm" style="margin-right: 4px;"
          >Buscar</button>
        </div>
        <p *ngIf="messageErrorTab2" style="color: red; font-weight: bold;">{{ messageErrorTab2 }}</p>
        <div style="margin-bottom: 20px;"></div>
        <table border="1" style="width: 100%; text-align: center; border-collapse: collapse;">
          <tr>
            <th style="background-color: #cde8f8">Chassi</th>
            <th style="background-color: #cde8f8">Data Solicitação</th>
            <th style="background-color: #cde8f8"> Status </th>
            <th style="background-color: #cde8f8"> Latitude </th>
            <th style="background-color: #cde8f8"> Longitude </th>
            <th style="background-color: #cde8f8">Data Localização</th>
            <th style="background-color: #cde8f8">Resposta Hyundai</th>
          </tr>
          <tr *ngFor="let item of historyChassi">
            <td>{{ item.chassi }}</td>
            <td>{{ item.request_date ? 
              (item.request_date.slice(6, 8) + '/' + item.request_date.slice(4, 6) + '/' + item.request_date.slice(0, 4) + ' ' + item.request_date.slice(8, 10) + ':' + item.request_date.slice(10, 12) + ':' + item.request_date.slice(12, 14)) 
              : '' }}   
            </td>
            <td>{{ item.response_api_hyundai }}</td>
            <td>{{ item.latitude }}</td>
            <td>{{ item.longitude }}</td>
            <td> {{ item.location_date ? 
              (item.location_date.slice(6, 8) + '/' + item.location_date.slice(4, 6) + '/' + item.location_date.slice(0, 4) + ' ' + item.location_date.slice(8, 10) + ':' + item.location_date.slice(10, 12) + ':' + item.location_date.slice(12, 14)) 
              : '' }}   
            </td>
            <td>{{ item.body_response }}</td>
          </tr>
        </table>
        <div *ngIf="chassiNotFound" style="color: red; margin-top: 30px;">
          <p> {{ chassiNotFound }} </p>
        </div>
      </div>
    </div>
  </div>


